module.exports = __webpack_public_path__ + "img/外框1.7e99c68b.png";